export class CommonFilter {
  MaritalStatusId : number;
  EmploymentStatusId : number;
  CauseId : number;
  DetectionYearOld : number;
  DisabilityMomentId : number;
  StudentSurveyType?: number;
  GroupCode: string;
  GroupName: string;
  StudentSurveyStatus?: number;
  Title: string;
  SupportedEducation: boolean;
  LevelOfDevelopmentTypeId: number;
  CertificateTypeId: number;
  ExpirationStatus: number;
  InfoProvider: number;
  ViewStatus: number;
  AnnounceType: number;
  Name: string;
  name: string;
  code: string;
  AnnounceId: number;
  NormalizedUserName: string;
  YearOld: number;
  EnsureConditionId: number
  DiplomaId: number;
  StudentName: string;
  IdentificationCode: string;
  NeedOfDisabilityId: number;
  StaffTypeOfDisabilityId: number;
  TypeOfDisabilityId: number;
  LevelId: number;
  IsStaffCreateByUser?: boolean;
  livingConditionId: number;
  LivingConditionId: number;
  InterventionStatusId: number;
  CaregiverId: number;
  year: string;
  Year: number;
  levelId: number;
  disTypeOfSchoolsId: number;
  EducationalSupportId: number;
  LocalGovernmentCoordination: boolean;
  CommunityCoordination: boolean;
  UnderstandDisabilityPolicy: boolean;
  TypeOfSchoolsId: number;
  TypeOfSchoolId: number;
  disStudentsId: number;
  modesOfEducationId: number;
  TypeofEducationId: number;
  typeOfEducationId: number;
  StudyModeId: number;
  SchoolLevelId: number;
  supportSpecificEquipment: boolean;
  disDisabilityCertificateType: number;
  certificateOfDisability: string;
  EducationalStatusId: number;
  DisDisabilityCertificateType: number;
  IsDisability: number;
  typeOfDisabilityId: number;
  TypeOfPersonnelId: number;
  PositionId: number;
  NationalityId: number;
  ContractTypeId: number;
  folkId: number;
  religionId: number;
  nationalityId: number;
  subordinateTypeId: number;
  schoolSubordinateType: number;
  EducationAndTrainingId: number;
  EducationAndTraningOrSchoolId: number;
  departmentId: number;
  UserName: string;
  UserId: number;
  isAdmin: boolean;
  GroupId: number;
  PassWord: string;
  isActivity: any;
  districtDepartmentId: number;
  CourseId: number;
  BlocId: number;
  SchoolId: number;
  ProvinceId?: number;
  DistrictId: number;
  WardId: number;
  SearchTerm: string;
  SenderReceiver: number;
  FromDate: string;
  ToDate: string;
  HasAttachment: boolean;
  Tag: number;
  PageIndex: number;
  PageSize: number;
  SortName: string;
  EspSortDirection: EspSortDirection;
  SortDirection: EspSortDirection;
  ClassId: number;
  StudentCode: string;
  FullName: string;
  CourseIdImport: number;
  ClassIdImport: number;
  Content: string;
  TuitionFeeValue: number;
  TuitionFeeStatus: number;
  TermTuitionFeeId: number;
  EducationAndTrainingCode: string;
  EducationAndTrainingName: string;
  Director: string;
  FolkId: number;
  ReligionId: number;
  natioNalityId: number;
  BoardId: number;
  PersonnelstatusId: number;
  SubjectId: number;
  QualificationId: number;
  RankId: number;
  StaffCode: string;
  Gender: number;
  StaffId: number;
  StudyOfYear: number; // nam nhap hoc
  AccountType: number;
  EATSId: number;
  IsApproved: boolean;
  YearOfBirth: number;
  TransferReason: string;
  TranferType: number;
  ProcessingNote: string;
  TnFromDate: string;
  TnToDate: string;
  TransferEatosId: string;
  TransferTypeId: number;
  AgeId?: number;
  StaffUnfostered: number;
  YearsOfService: number;
  YearsOfTeaching: number;
  PositionGVId: number;
  TransferToEatosId: number;
  TransferToEatosName : string;
}

export enum EspSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
